export default {
    "name": "InitialVendorPageLoad",
    "kind": "HoudiniQuery",
    "hash": "29a4201d7d5e3fb4e6db5c2e79cf308e6a514976711cdf1a58861d85b77e2466",

    "raw": `query InitialVendorPageLoad($filter: PaymentMethodFilter) {
  states {
    country
    stateAbbreviation
    stateCode
    stateName
  }
  glCategories {
    id
    name
  }
  salesOrderTerms {
    id
    name
  }
  paymentMethods(filter: $filter) {
    id
    name
  }
  userAccounts {
    id
    name
  }
  vendorTypes
  settingValues {
    api {
      addressServiceEnabled
    }
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "states": {
                "type": "State",
                "keyRaw": "states",

                "selection": {
                    "fields": {
                        "country": {
                            "type": "String",
                            "keyRaw": "country",
                            "nullable": true,
                            "visible": true
                        },

                        "stateAbbreviation": {
                            "type": "String",
                            "keyRaw": "stateAbbreviation",
                            "nullable": true,
                            "visible": true
                        },

                        "stateCode": {
                            "type": "Int",
                            "keyRaw": "stateCode",
                            "nullable": true,
                            "visible": true
                        },

                        "stateName": {
                            "type": "String",
                            "keyRaw": "stateName",
                            "nullable": true,
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "glCategories": {
                "type": "GlCategory",
                "keyRaw": "glCategories",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true,
                            "nullable": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "nullable": true,
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "salesOrderTerms": {
                "type": "Term",
                "keyRaw": "salesOrderTerms",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true,
                            "nullable": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "paymentMethods": {
                "type": "PaymentMethod",
                "keyRaw": "paymentMethods(filter: $filter)",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "userAccounts": {
                "type": "UserAccount",
                "keyRaw": "userAccounts",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "vendorTypes": {
                "type": "String",
                "keyRaw": "vendorTypes",
                "visible": true
            },

            "settingValues": {
                "type": "SettingValues",
                "keyRaw": "settingValues",

                "selection": {
                    "fields": {
                        "api": {
                            "type": "ApiConfigSettingValues",
                            "keyRaw": "api",

                            "selection": {
                                "fields": {
                                    "addressServiceEnabled": {
                                        "type": "Boolean",
                                        "keyRaw": "addressServiceEnabled",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "filter": "PaymentMethodFilter"
        },

        "types": {
            "PaymentMethodFilter": {
                "customerPaymentMethod": "Boolean",
                "requiresDocumentNumber": "Boolean",
                "vendorPaymentMethod": "Boolean"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=0fca91ee7bd0c28beea4d3e87d44dc7072cd7ef2d969a3a6b6cefac1296166df";